import { Component, Input } from '@angular/core';

import {
  Antibiotic,
} from '@app/core/patient-requests';

@Component({
  selector: 'afoone-request-antibiotics',
  templateUrl: './request-antibiotics.component.html',
  styleUrls: ['./request-antibiotics.component.css'],
})
export class RequestAntibioticsComponent {
  @Input()
  public antibiotics: Antibiotic[];

  // obtener el nombre del virus, bacteria o lo que sea, elinando caracteres especiales (todos los no word  pero no los espacios)
  public get bacteriumNames(): string[] {
    const name =
      this.antibiotics && this.antibiotics[0] && this.antibiotics[0][''];

    return name ? name.replace(/[^a-zA-Z0-9 #]/g, '').split('#').filter(i=> i) : [];
  }
}
